var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.607 21.021l7.778 7.778 2.828 1.414-1.414-2.828-7.778-7.778 7.778-7.778L30.213 9l-2.828 1.415-7.778 7.778-7.779-7.78L9 9l1.414 2.828 7.779 7.779-7.779 7.778L9 30.213l2.828-1.413 7.779-7.779z",
    fill: "#fff"
  })));
}

export default SvgCrossIcon2;